import { createBrowserRouter, Navigate, useNavigate } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { createBoard } from '../api/plannerApi';
import PlannerPage from '../pages/PlannerPage';
import CheckInPage from '../pages/CheckInPage';

function CreateAndRedirect() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    createBoard()
      .then((r) => navigate(`/planner/${r.editToken}`, { replace: true }))
      .catch(() => setError('Could not create a new planner board.'));
  }, [navigate]);

  if (error) return <div className="p-8 text-center text-red-700">{error}</div>;
  return <div className="p-8 text-center opacity-60">Creating your board…</div>;
}

export const router = createBrowserRouter([
  { path: '/', element: <CreateAndRedirect /> },
  { path: '/planner/:token', element: <PlannerPage /> },
  { path: '/planner/:token/checkin', element: <CheckInPage /> },
  { path: '*', element: <Navigate to="/" replace /> },
]);
